export default {
  FETCH_PAYMENTS_SUCCESS: 'FETCH_PAYMENTS_SUCCESS',
  FETCH_PAYMENTS_LOADING: 'FETCH_PAYMENTS_LOADING',
  FETCH_PAYMENTS_REJECT: 'FETCH_PAYMENTS_REJECT',
  FETCH_PAYMENTS_FAILED: 'FETCH_PAYMENTS_FAILED',

  FETCH_PAYMENTDETAILS_LOADING: 'FETCH_PAYMENTDETAILS_LOADING',
  FETCH_PAYMENTDETAILS_FAILED: 'FETCH_PAYMENTDETAILS_FAILED',
  FETCH_PAYMENTDETAILS_SUCCESS: 'FETCH_PAYMENTDETAILS_SUCCESS',
  FETCH_PAYMENTDETAILS_REJECT: 'FETCH_PAYMENTDETAILS_REJECT',

  GET_PAYMENTS_EXCEL_FILE_LOADING: 'GET_PAYMENTS_EXCEL_FILE_LOADING',
  GET_PAYMENTS_EXCEL_FILE_SUCCESS: 'GET_PAYMENTS_EXCEL_FILE_SUCCESS',
  GET_PAYMENTS_EXCEL_FILE_REJECT: 'GET_PAYMENTS_EXCEL_FILE_REJECT',
  GET_PAYMENTS_EXCEL_FILE_FAILED: 'GET_PAYMENTS_EXCEL_FILE_FAILED'
};
